import { Row, Col } from "../../App.styles";

const MultipleChoice = ({ useQuery }) => {
  const { multiplechoice } = useQuery();

  return (
    <>
      <Row>
        <Col>
          <p>Complete by: Multiple Choice</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            Answers (separated by commas, correct one first): {multiplechoice}
          </p>
        </Col>
      </Row>
    </>
  );
};

export default MultipleChoice;
